import React, { useEffect, useState } from 'react';
import { pathHome } from '../../path';
import styles from './products-page.module.css';
import { Link } from 'react-router-dom';
import { addDocBd, deleteDocBd, getDocsOrderByBd } from '../../firebase';
import LoaderPage from '../../components/LoaderPage/LoaderPage';
import AddProducts from '../../components/AddProducts/AddProducts';
import CopyBtn from '../../elemets/CopyBtn/CopyBtn';
import DownloadBtn from '../../elemets/DownloadBtn/DownloadBtn';
import { isArraysEqual, isArraysIncludes } from '../../helper';
import { getProductObject } from '../../helperProject';

export default function ProductsPage() {
  const [popupAddProducts, setPopupAddProducts] = useState(false);
  const [loaderPage, setLoaderPage] = useState(false);
  const [restartPage, setRestartPage] = useState(false);

  const [productsArray, setProductsArray] = useState([]);

  useEffect(() => {
    setLoaderPage(true);
    const getProducts = async () => {
      const products = await getDocsOrderByBd('products', 'productText');
      if (products) {
        setProductsArray(products);
      }
      setLoaderPage(false);
    };
    getProducts();
  }, [restartPage]);

  const deleteProduct = async (id) => {
    setLoaderPage(true);
    const isDeleteProduct = window.confirm('Видалити продукт?');
    if (isDeleteProduct) {
      const ifDeleteProduct = await deleteDocBd('products', id);
      if (ifDeleteProduct) {
        const newProductArray = productsArray.filter((product) => product.id != id);
        setProductsArray(newProductArray);
        alert('Видалено успішно!');
      } else {
        alert('Не вдолося видалити!');
      }
    }
    setLoaderPage(false);
  };

  const renderProducts = (products) => {
    return products.map((item) => {
      return (
        <div key={item.id} className={styles.product_block}>
          <div
            className={
              item.newProduct
                ? styles.product_info + ' ' + styles.product_info_new
                : styles.product_info
            }>
            {item.productText}
          </div>
          <div className={styles.delete_product_wrapper} onClick={() => deleteProduct(item.id)}>
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3 3H18V18C18 19.1046 17.1046 20 16 20H5C3.89543 20 3 19.1046 3 18V3Z"
                fill="#FF5C5E"></path>
              <rect width="21" height="2" rx="1" fill="#FF5C5E"></rect>
            </svg>
          </div>
        </div>
      );
    });
  };

  const verificationArrey = (arrayВownloadKeys, arrayProductKeys) => {
    // console.log('arrayВownloadKeys === ', arrayВownloadKeys);
    // console.log("[...arrayProductKeys, 'newProduct'] === ", [...arrayProductKeys, 'newProduct']);

    let isVerification = 0;
    arrayВownloadKeys.forEach((value) => {
      const isIncludes = isArraysIncludes([...arrayProductKeys, 'newProduct'], value);
      if (isIncludes) {
        isVerification++;
      }
    });

    if (arrayВownloadKeys.length === isVerification) {
      return true;
    }
    return false;
  };

  // Додає дані в базу данних
  const addDocs = (dataString) => {
    const data = JSON.parse(dataString);

    setLoaderPage(true);

    let indexValue = 0;

    const addDoc = async () => {
      const isAddDoc = await addDocBd('products', data[indexValue].id, {
        ...data[indexValue],
        newProduct: false,
      });
      if (isAddDoc) {
        indexValue++;
        if (data.length > indexValue) {
          addDoc();
        }
        if (data.length === indexValue) {
          setLoaderPage(false);
          setRestartPage(!restartPage);
          alert('Додано успішно!');
        }
      } else {
        if (indexValue === 0) {
          alert('Не вдалось додати дані!');
        }
        if (indexValue > 0) {
          alert('Не всі дані були додані');
        }
        setRestartPage(!restartPage);
        setLoaderPage(false);
      }
    };

    if (data && data.length) {
      const isVerification = verificationArrey(
        Object.keys(data[0]),
        Object.keys(getProductObject()),
      );

      if (!isVerification) {
        alert('Не вірний формат даних!');
        setLoaderPage(false);
        return;
      }
      addDoc();
    } else {
      setLoaderPage(false);
    }
  };

  //Додаэ даны в буфер обмыну
  const writeData = (data) => {
    navigator.clipboard
      .writeText(JSON.stringify(data))
      .then(() => {
        alert('Скопійовано');
      })
      .catch(() => {
        alert('Не вдалося скопіювати!');
      });
  };

  // Отримуэ даны з буфера обмыну
  const readData = () => {
    navigator.clipboard
      .readText()
      .then((data) => {
        addDocs(data);
      })
      .catch(() => {
        alert('Не вдалося завантажити! (Код ошибки: 0001)');
      });
  };

  const downloadData = () => {
    let isDownloadData = window.confirm('Завантажити дані?');

    if (isDownloadData) {
      readData();
    }
  };

  return (
    <>
      <div className={styles.header_wrapper}>
        <Link className={styles.header_link} to={`/${pathHome}/home`}>
          <svg
            width="12"
            height="18"
            viewBox="0 0 12 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M0 9L11.25 0.339745V17.6603L0 9Z" fill="white" />
          </svg>
          Головна
        </Link>
        <div>{productsArray.length} шт.</div>
        <svg
          onClick={() => setPopupAddProducts(true)}
          className={styles.interaction_item}
          width="35"
          height="36"
          viewBox="0 0 35 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <rect y="2.60376" width="34.7273" height="33.0189" rx="10" fill="#A22CA7" />
          <path
            d="M16.2182 26.4091V11.4091H18.7636V26.4091H16.2182ZM9.99089 20.1818V17.6364H24.9909V20.1818H9.99089Z"
            fill="white"
          />
        </svg>
      </div>
      <div className={styles.content_wrapper}>
        <div className={'df gap_20 mb_10'}>
          {productsArray.length ? (
            <div onClick={() => writeData(productsArray)}>
              <CopyBtn textBtn="Копіювати все" />
            </div>
          ) : (
            ''
          )}

          <div onClick={() => downloadData()}>
            <DownloadBtn textBtn="Завантажити" />
          </div>
        </div>
        {productsArray.length ? (
          renderProducts(productsArray)
        ) : loaderPage ? (
          <div>Загрузка...</div>
        ) : (
          <div>Пусто:)</div>
        )}
      </div>
      {popupAddProducts && (
        <AddProducts
          setPopup={setPopupAddProducts}
          productsArray={productsArray}
          setProductsArray={setProductsArray}
        />
      )}
      {loaderPage && <LoaderPage />}
    </>
  );
}
